// GPP header encoder/decoder (multi-section) using Range(Fibonacci)-style coding.
// Type (6b)=3, Version (6b)=1. Sections are encoded as ranges, each (start,len) via Fibonacci code.
class BitWriter {
    bits = [];
    writeN(v, n) {
        for (let i = n - 1; i >= 0; i--)
            this.bits.push((v >> i) & 1);
    }
    toBase64Url() {
        const bytes = [];
        for (let i = 0; i < this.bits.length; i += 8) {
            let byte = 0;
            for (let j = 0; j < 8 && i + j < this.bits.length; j++)
                byte = (byte << 1) | this.bits[i + j];
            if (i + 8 > this.bits.length)
                byte <<= 8 - (this.bits.length - i);
            bytes.push(byte);
        }
        return Buffer.from(bytes)
            .toString('base64')
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/g, '');
    }
    writeFib(n) {
        fibEncodeInt(n).forEach((b) => this.writeN(b, 1));
    }
}
class BitReader {
    bits = [];
    i = 0;
    constructor(b64u) {
        const b64 = b64u.replace(/-/g, '+').replace(/_/g, '/');
        const buf = Buffer.from(b64 + '==='.slice((b64.length + 3) % 4), 'base64');
        for (const byte of buf)
            for (let b = 7; b >= 0; b--)
                this.bits.push((byte >> b) & 1);
    }
    readN(n) {
        let v = 0;
        for (let k = 0; k < n; k++)
            v = (v << 1) | this.bits[this.i++];
        return v;
    }
    readFib() {
        return fibDecodeInt(this);
    }
}
function fibSeqUpTo(n) {
    const F = [1, 2];
    while (F[F.length - 1] < n)
        F.push(F[F.length - 1] + F[F.length - 2]);
    return F;
}
function fibEncodeInt(n) {
    if (n < 1)
        throw new Error('fibEncodeInt: n>=1');
    const F = fibSeqUpTo(n);
    const bits = Array(F.length).fill(0);
    let rem = n;
    for (let i = F.length - 1; i >= 0; i--)
        if (F[i] <= rem) {
            bits[i] = 1;
            rem -= F[i];
            i--;
        }
    // trim trailing zeros so the codeword ends with 1 before appending terminator
    const lastOne = bits.lastIndexOf(1);
    const core = lastOne >= 0 ? bits.slice(0, lastOne + 1) : [0];
    return core.concat(1); // ensures ...11 at end when decoded
}
function fibDecodeInt(r) {
    let prev = 0, idx = 0, value = 0;
    const F = [1, 2];
    const needF = (k) => {
        while (F.length <= k)
            F.push(F[F.length - 1] + F[F.length - 2]);
    };
    while (true) {
        const bit = r.readN(1);
        if (bit === 1 && prev === 1)
            break;
        needF(idx);
        if (bit === 1)
            value += F[idx];
        prev = bit;
        idx++;
    }
    return value;
}
function toRanges(sections) {
    const s = [...new Set(sections)].sort((a, b) => a - b);
    if (s.length === 0)
        return [];
    const ranges = [];
    let start = s[0], prev = s[0];
    for (let i = 1; i < s.length; i++) {
        if (s[i] === prev + 1) {
            prev = s[i];
            continue;
        }
        ranges.push([start, prev]);
        start = prev = s[i];
    }
    ranges.push([start, prev]);
    return ranges;
}
function expandRanges(ranges) {
    const out = [];
    for (const [a, b] of ranges)
        for (let x = a; x <= b; x++)
            out.push(x);
    return out;
}
export function encodeGppHeader(sections) {
    const w = new BitWriter();
    w.writeN(3, 6); // type
    w.writeN(1, 6); // version
    const ranges = toRanges(sections);
    w.writeFib(ranges.length);
    for (const [a, b] of ranges) {
        const len = b - a + 1;
        w.writeFib(a);
        w.writeFib(len);
    }
    return w.toBase64Url();
}
export function decodeGppHeader(b64u) {
    const r = new BitReader(b64u);
    const type = r.readN(6);
    const version = r.readN(6);
    const rangeCount = r.readFib();
    const ranges = [];
    for (let i = 0; i < rangeCount; i++) {
        const start = r.readFib();
        const len = r.readFib();
        ranges.push([start, start + len - 1]);
    }
    return { type, version, sections: expandRanges(ranges) };
}
export function joinGpp(headerB64u, ...sectionB64u) {
    return [headerB64u, ...sectionB64u].join('~');
}
//# sourceMappingURL=header.js.map